import _ from 'lodash'

/*
You can prevent navigation as shown in commented out code.  However, when using the current state of recordFormView
there is no good way of setting the form to pristine after a successful submit.

there's a good spot in the form view service but not all forms use it.  Ideally, we'd rewrite the recordFormView's
submit so it returns a SaveFormConfig or SubmitFormConfig and the we could more tightly control the flow
when submitting a form
*/

//import message from './message'

//Directive.$inject = ['$window', "$transitions"]
//function Directive($window, transitions){
function Directive(){
  return {
    restrict: 'A',
    require: 'form',
    link: function postLink(scope, iElement, iAttrs, formController){
      // const registration = transitions.onStart(undefined, transition => {
      //   if(promptForNavigation(formController, transition.to())){
      //     var navigate = $window.confirm(message)
      //     if(!navigate){
      //       transition.abort()
      //     }
      //   }
      // })
      // scope.$on('$destroy', () => {
      //   registration()
      // })

      scope.$on('onBeforeUnload', function(event){
        var preventNavigation = promptForNavigation(formController)
        if(preventNavigation){
          event.preventDefault()
        }
      })
    }
  }

  function promptForNavigation(formController, toState){
    if(_.get(toState, 'name') === 'login'){
      return false
    }
    return formController.$dirty
  }
}

export default Directive
